import { render } from "./IconStar.vue?vue&type=template&id=3607215f"
import script from "./IconStar.vue?vue&type=script&lang=ts"
export * from "./IconStar.vue?vue&type=script&lang=ts"
script.render = render

export default script